/**
 * @file hero-carousel.js
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakHeroCarousel = {
    attach: function (context, settings) {
      $(".hero-carousel--section").each(function () {
        const imageSlider = $(this).find(".image-slider-wrapper");
        const contentSlider = $(this).find(".content-slider");

        imageSlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: contentSlider,
          focusOnSelect: false
        });

        contentSlider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          asNavFor: imageSlider,
          dots: true,
        });
      });
    },
  };
})(jQuery, Drupal, once);
